// @ts-nocheck
// import { infoProps } from "@store/Themes/common/props/info"; // Greif
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Greif Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { infoProps } from "@store/Themes/common/props/info";
/* Greif Custom Code - End */

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            /* Greif Custom Code - Start */
            tooltipBody: css`
                background: ${getColor("common.accent")};
                color: ${getColor("text")};
                box-shadow: ${x => x.theme.shadows[1]};
            `,
            tooltipContainer: css`
                &::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -6px;
                    border-width: 6px;
                    border-style: solid;
                    border-color: ${getColor("common.accent")} transparent transparent transparent;
                }
            `,
            /* Greif Custom Code - End */
        },
        typographyProps: {
            weight: "normal",
        },
    },
};

export default tooltip;
